<template>
  <v-container fluid tag="div">
    <v-layout
      class="px-2"
      wrap
    >
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Suche"
        single-line
        hide-details
      ></v-text-field>
      <v-btn
        style="margin-top:10px;"
        elevation="2"
        color="primary"
        >
        <download-csv
          :data="exportJson"
          :name="`ocatest_export_${new Date().toJSON().slice(0,10).replace(/-/g,'.')}.csv`"
          >
          {{ lang.download_data }}
        </download-csv>
      </v-btn>
      <v-data-table
        dense
        :rows-per-page-items="[15, 25, 50, 75]"
        :headers="headers"
        :items="tests"
        :search="search"
        class="tests-table elevation-1"
      >
        <template v-slot:items="props">
          <td class="py-0 text-xs-left">{{ getName(props.item) }}</td>
          <td class="py-0 text-xs-left">{{ props.item.telefonszam }}</td>
          <td class="py-0 text-xs-left">{{ props.item.email }}</td>
          <td class="py-0 text-xs-left">{{ props.item.origin }}</td>
          <td class="py-0 text-xs-left">{{ props.item.date }}</td>
          <td class="py-0 text-xs-left">{{ props.item.kor }}</td>
          <td class="py-0 text-xs-left">{{ props.item.nem != '0' ? 'Herr' : 'Frau' }}</td>
          <td class="py-0">
            <v-autocomplete
              :items="items"
              :value="props.item.statusz"
              v-model="props.item.statusz"
              @change="updateStatus(props.item.id, props.item.statusz)"
            ></v-autocomplete>
          </td>
          <td class="py-0">
            <v-autocomplete
              :items="assignees"
              :value="props.item.assigneeId"
              item-text="monogram"
              item-value="assigneeId"
              v-model="props.item.assigneeId"
              clearable
              @change="updateAssignee(props.item.id, props.item.assigneeId)"
            ></v-autocomplete>
          </td>
          <td class="py-0 printbutton"><v-icon style="cursor: pointer" @click="_openGraph_(props.item)">print</v-icon></td>
          <td class="py-0 deletebutton"><DeleteButton :id="props.item.id" backendRoute="delete" @itemDeleted="collectResults"/></td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Ihre Suche nach "{{ search }}" Es wurden keine Ergebnisse gefunden.
          </v-alert>
        </template>
      </v-data-table>
    <!-- </v-flex> -->

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
  export default {
    data () {
      return {
        search: '',
        assignees: [],
        items: [
          'hereingerufen',
          'einenTermin abstimmen',
          'Warten auf Anruf',
          'Warten auf Rückruf',
          'Auswertung ist erfolgt',
          'gelöscht',
          'kein Interesse',
          'falsche Telefonnummer',
          'Mailadresse falsch',
          'Tel. Nummer und Mailadr. falsch',
          'Nicht erreicht',
          'T. vereinbaren für tel. Auswertung',
          'T. vereinbaren für pers. Auswertung',
          'T. für pers. Auswertung ist vereinbart',
          'T. für tel. Auswertung ist vereinbart',
          'Mail I versandt',
          'Mail II versandt',
          'Mail III versandt',
          'Auswertung ist erfolgt',
          'Buch gekauft',
          'Buch und Heimkurs gekauft',
          'DIV 6 Kurs gestartet',
          'Auditing Programm gestartet'
        ],
        tests: [],
      }
    },
    async created() {
      await this.collectAssignees()
      this.collectResults()
    },
    methods: {
      async collectAssignees(){
        const res = await axios.get('assignees/collect.php')
        const assignees = res.data.data
        this.assignees = assignees
      },
      getName ({ nev, keresztnev, vezeteknev }) {
        return keresztnev ? `${keresztnev} ${vezeteknev}` : nev
      },
      changeLocale () {
        this.$vuetify.lang.current = 'sv'
      },
      collectResults(){
        axios.get('read.php')
        .then(response => {
          let tests = response.data
          this.tests = tests.data
        })
      },
      updateAssignee(tesztId, newAssignee){
        axios.post('update_assignee.php?id=' +tesztId + '&assignee=' + newAssignee)
        .then(response => {
        })
      },
      updateStatus(tesztId, newStatus){
        axios.post('update.php?id=' +tesztId + '&status=' + newStatus)
        .then(response => {
        })
      },
      _openGraph_(item){
        const link = `${item.link}&teljesnev=${this.getName(item)}`
       let action = 'https://oca.denke-plus.de/oca/oxfordi_teszt_oca/oca_graf.php?access=' + this.$cookie.get('x-access-token') + '&id=' + item.id + link;

        var form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", action);

        form.setAttribute("target", "view");

        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "message");
        hiddenField.setAttribute("value", link);
        form.appendChild(hiddenField);
        document.body.appendChild(form);

        window.open('', 'view');

        form.submit();
      },
    },
    computed: {
      exportJson () {
        return this.tests.map(test => {
          const t = {}
          t.name = this.getName(test)
          t.email = test.email
          t.telefonnummer = test.telefonszam
          t.alter = test.kor
          t.gesch = test.nem != '0' ? 'Herr' : 'Frau'
          t.origin = test.origin
          t.date = test.date
          t.zustand = test.statusz
          return t
        })
      },
      headers () {
        return [
          {text: 'Name', value: 'nev', sortable: false},
          { text: 'Telefonnummer', value: 'telefonszam', sortable: false},
          { text: 'Email', value: 'email', sortable: false},
          { text: 'Origin', value: 'origin', sortable: false},
          { text: 'Date', value: 'nem', sortable: false},
          { text: 'Alter', value: 'kor', sortable: false},
          { text: 'Gesch.', value: 'nem', sortable: false},
          { text: 'Zustand', value: 'statusz', sortable: false},
          { text: this.lang.megbizott, value: 'assignee', sortable: false},
          { text: ''},
          { text: ''}
        ]
      }
    },
    components: {
      'DeleteButton': () => import('./DeleteButton.vue')
    }
  }
</script>

<style lang="css">

.tests-table {
  width: 100% !important;
}

.tests-table .v-input__slot {
  margin-bottom: 0 !important;
}

.tests-table .v-input {
  padding-top: 0 !important;
  font-size: 13px !important;
}

.tests-table td {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.tests-table th {
  padding: 7px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.v-text-field__details {
  display: none;
}
.v-input__slot {
  margin: 0 !important;
}

/* .v-list {
  text-transform: capitalize;
} */

.v-input__slot {
  margin-bottom: 20px !important;
}
.v-datatable__actions__select{
  visibility: hidden !important;
}
.v-table__overflow{
  margin-top: 5px;
}
.printbutton, .deletebutton {
padding:0!important;
}
.deletebutton .v-btn {
    min-width: 0;
    padding: 0px!important;
    margin-left:0px;
    margin-right:10px;
}

.deletebutton .v-btn:hover:before, .deletebutton .v-btn:focus:before {
    background-color: transparent;
}
.v-datatable .sortable .v-icon {
  display:none!important;
}
</style>
